<template lang="html">
  <div class="radio-primary-styled">
    <input
      @change="$emit('change', name, value)"
      type="radio"
      class="form-check-input"
      :checked="checked"
      :name="name"
      :value="value">
    <span class="checkmark"><span></span></span>
  </div>
</template>

<script>
export default {
  props: {
    name: String,
    value: String | Number | Boolean,
    checked: Boolean
  }
}
</script>

<style lang="scss">
  @import '../../../scss/colors';

  .radio-primary-styled {
    position: relative;
    width: 1rem;
    height: 1rem;
    margin: auto;
    flex: 0 1 auto;

    & .checkmark {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      // height: 1rem;
      // width: 1rem;
      background-color: transparent;
      border: solid 1px $secondary;

      & span {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        height: 100%;
        width: 100%;
        background-color: $primary;
        opacity: 0;
      }
    }

    & .checkmark, span {
      border-radius: 50%;
    }

    & input {
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      opacity: 0;
      z-index: 1;
      // width: calc(100% - 2rem);
      cursor: pointer;
    }

    & input:disabled ~ .checkmark {
      opacity: 0.5;
    }

    & input:checked ~ .checkmark {
      border: 4px double $primary;
      border-radius: 50%;

      & span {
        opacity: 1;
        border-radius: 50%;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ui/forms/RadioPrimaryStyled.vue